import type { GrassCampaignResponseDto } from '@/api/campaign/grass/grass.dto';

import { ChristmasTree } from './components/ChristmasTree/template';
import * as D from './data';
import { calculateUserContribution, useTreeState } from './logic';

interface TreeProps {
  grassData: GrassCampaignResponseDto | null;
  totalContributionData: number;
}

export function Tree({ grassData, totalContributionData }: TreeProps) {
  const pixels = D.PROCESSED_PIXELS;
  const { currentPhase, fillCount } = useTreeState(
    grassData,
    totalContributionData,
  );
  const userContribution = calculateUserContribution(grassData);

  return (
    <ChristmasTree
      pixels={pixels}
      currentPhase={currentPhase}
      fillCount={fillCount}
      userContribution={userContribution}
      totalContributionData={totalContributionData}
    />
  );
}
